import React, { Component } from 'react';
import { Button, Grid, Icon, Label } from 'semantic-ui-react';
import { source } from 'react-aim';
import { dispatch } from '@rematch/core';
import Accordion from '@zippytech/react-toolkit/Accordion';
import '@zippytech/react-toolkit/Accordion/index.css';
import Description from './PracticeFlow/Desctiption'
import AssignRole from './PracticeFlow/Roles'
import ShowPlaybookMetaData from "../drive/modals/ShowPlaybookMetaData";

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext("Resource Pane")
    }
})
class PracticeFlowResourcePane extends Component {

    constructor(props) {
        super(props);
        this.state = {
            overrideChildren: false,
            modalFlag: false,
            schema:null,
            shemaUpdationKey:"",
        }
        this.editActivity = this.editActivity.bind(this);
        this.propagateChangesToChildren = this.propagateChangesToChildren.bind(this);
    }
    componentWillMount() {
        dispatch.createPack.setValidationCheckFlag(false)
    }
    propagateChangesToChildren() {
        this.props.selectedPracticeFlowActivity.applyChangesOnChildren = true;
        this.props.selectedPracticeFlowActivity.packId = this.props.selectedPracticeLibrary._id;
        dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
    }
    editActivity() {
        this.props.selectedPracticeFlowActivity.applyChangesOnChildren = false;
        this.props.selectedPracticeFlowActivity.packId = this.props.selectedPracticeLibrary._id;
        dispatch.createPack.editActivityAsync(this.props.selectedPracticeFlowActivity)
    }
    componentDidUpdate() {
        if (this.props.selectedPracticeFlowActivity && !this.props.selectedPracticeFlowActivity.overrideChildren) {
            this.props.selectedPracticeFlowActivity.overrideChildren = false;
        }
    }
    isDesigner = () => {
        const loggdinUserId = this.props.user.email;
        let author =
          this.props.selectedPracticeLibrary &&
          this.props.selectedPracticeLibrary.participants &&
          this.props.selectedPracticeLibrary.participants.filter((participant) => {
            return participant.role === "author";
          });
        if (author && author.length > 0) {
          return author.find((author) => author.email === loggdinUserId);
        }
        return null;
      };
      isAuthor = () => {
        let authors =
          this.props.currentOrganization &&
          this.props.currentOrganization.users &&
          this.props.currentOrganization.users.filter(
            (el) =>
              el.accountUserId === this.props.user._id &&
              el.role === "workspaceOwner"
          );
        if (authors && authors.length > 0) {
          return true;
        }
        return null;
      };
      setMetaDataFlag = async (flag,schema,shemaUpdationKey) => {
        await this.setState({ modalFlag: flag, schema:schema,shemaUpdationKey:shemaUpdationKey });
      };
    render() {
        // below changes for KLM-9602
        let metaDataFlag = true;
        // if (this.isAuthor() || this.isDesigner()) {
        //   metaDataFlag = true;
        // }
        const expandTool = <div className="plusMinusIcons"  >
            <Icon className="close" name="plus circle" />
            <Icon className="open" name="minus circle" />
        </div>

        let raci = this.props.selectedPracticeFlowActivity.raci;

        let raciLength = raci ?
            (raci.r ? raci.r.length : 0 +
                raci.c ? raci.c.length : 0 +
                    raci.i ? raci.i.length : 0) + 1 : 0

        let counts = {}

        if (this.props.selectedPracticeLibrary) {
            counts.assignmentsLength = <Label>{raciLength}</Label>
        }

        return (

            <div className="accordianBox w_100">
                <div className={this.props.selectedPracticeLibrary.status === 0 ?
                    "accordianPanel w_100" : "accordianPanel w_100"}>
                    <Accordion expandTool={expandTool} key={1} horizontal className="practiceFlowResourcePane hidden_Checkbox" transitionDuration={this.props.transactionTime} enableKeyboardNavigation={false}>
                        <div tabTitle="Activity Details">
                            <div className="acc-header">Activity Details</div>
                            <Description name='Description' selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity} parentPhase={this.props.parentPhase} status={this.props.selectedPracticeLibrary.status} selectedAccount={this.props.selectedAccount} />
                        </div>
                        <div tabTitle={<div>Assignments {counts.assignmentsLength} </div>}>
                            <Grid style={{ marginTop: "7.5px" }}>
                                <Grid.Row>
                                    <Grid.Column width={8}>
                                        <div className="acc-header">Assignments {counts.assignmentsLength}</div>
                                    </Grid.Column>
                                    <Grid.Column width={8}>
                                        {this.props.selectedPracticeFlowActivity && this.props.selectedPracticeLibrary.status === 0 && this.props.selectedPracticeFlowActivity.isParentNode &&
                                            <Button className="button-info float-right" content='Propagate RACI' icon='sort content ascending' onClick={this.propagateChangesToChildren} />
                                        }
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                            <AssignRole
                                name='Assign Role'
                                selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                                communityOptions={this.props.selectedPracticeLibrary.communities}
                                activityActions={this.props.activityActions}
                                status={this.props.selectedPracticeLibrary.status}
                                editActivity={this.editActivity}
                                nameOfHelpText='Assigned Roles Card' />
                        </div>
                        <div tabTitle="MetaData">
                            <div className="acc-header">
                                MetaData 
                                <span
                                    style={{ margin: "0 20px" }}
                                    className="clr-gray fs_italic"
                                  >
                                   {(metaDataFlag && this.props.selectedPracticeFlowActivity &&
                                    this.props.selectedPracticeFlowActivity.metaData) ? (
                                        <Button
                                        disabled={!metaDataFlag}
                                        content="Edit MetaData"
                                        className="button-submit float-right "
                                        type="button"
                                        onClick={() => this.setMetaDataFlag(true, this.props.selectedPracticeFlowActivity.metaData, "metaData")}
                                        />
                                    ) : null}
                                </span>
                            </div>
                            {this.props.selectedPracticeFlowActivity &&
                                this.props.selectedPracticeFlowActivity.metaData ? (
                                  <div className="resourcePaneOverflow">
                                    <pre>
                                      {JSON.stringify(
                                        this.props.selectedPracticeFlowActivity.metaData,
                                        null,
                                        2
                                      )}
                                    </pre>
                                  </div>
                            ) : <span className="clr-orange">No metaData to display</span>}
                        </div>
                    </Accordion>
                </div>
                <ShowPlaybookMetaData
                    open={this.state.modalFlag}
                    setMetaDataFlag={this.setMetaDataFlag}
                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                    selectedPracticeFlowActivity={this.props.selectedPracticeFlowActivity}
                    metaDataSchema={
                        this.state.schema
                    }
                    view="configure"
                    shemaUpdationKey={this.state.shemaUpdationKey}
                />
            </div>
        )
    }
}
export default PracticeFlowResourcePane;